module.exports = __webpack_public_path__ + "img/BULB_80X30.77c55c40.png";